var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _path10, _path11, _line, _line2, _line3, _line4, _line5, _rect4, _path12, _ellipse, _path13, _rect5, _path14, _path15, _path16, _path17, _path18, _line6, _line7, _line8, _line9, _line10, _rect6, _path19, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 99,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.1716,
    y: 16.2694,
    width: 69.9093,
    height: 55.2124,
    rx: 9.82384,
    stroke: "#D6D6D6",
    strokeWidth: 0.248705,
    strokeDasharray: "1.99 4.97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19878 50.9845C4.6622 35.9504 20.5035 24.1985 39.0297 16.5789C57.6819 8.90754 81.0342 4.2451 102.017 10.7532C121.879 16.9135 128.788 32.5366 135.426 46.4775C141.48 59.1899 148.938 74.1534 136.821 83.8428C125.407 92.9694 103.342 86.1635 85.1218 86.7034C68.2608 87.203 51.4847 93.2576 36.865 86.8046C18.5452 78.7184 3.7589 65.2548 4.19878 50.9845Z",
    fill: "white",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.38068,
    y: 18.2134,
    width: 22.0386,
    height: 20,
    rx: 2.98446,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3999 21.7134C22.2033 21.7134 21.2333 22.6834 21.2333 23.88C21.2333 24.0106 21.2448 24.1386 21.267 24.2628L18.1132 26.4704C18.0972 26.4816 18.082 26.4936 18.0677 26.5063C17.6999 26.2184 17.2366 26.0467 16.7333 26.0467C15.5366 26.0467 14.5666 27.0168 14.5666 28.2134C14.5666 29.41 15.5366 30.38 16.7333 30.38C17.2366 30.38 17.6999 30.2084 18.0677 29.9204C18.082 29.9331 18.0972 29.9451 18.1132 29.9563L21.267 32.164C21.2448 32.2882 21.2333 32.4161 21.2333 32.5467C21.2333 33.7433 22.2033 34.7134 23.3999 34.7134C24.5965 34.7134 25.5666 33.7433 25.5666 32.5467C25.5666 31.3501 24.5965 30.38 23.3999 30.38C22.6981 30.38 22.0742 30.7138 21.6782 31.2312L18.692 29.1408C18.8253 28.8597 18.8999 28.5452 18.8999 28.2134C18.8999 27.8815 18.8253 27.5671 18.692 27.2859L21.6782 25.1956C22.0742 25.713 22.6981 26.0467 23.3999 26.0467C24.5965 26.0467 25.5666 25.0767 25.5666 23.88C25.5666 22.6834 24.5965 21.7134 23.3999 21.7134ZM22.2333 23.88C22.2333 23.2357 22.7556 22.7134 23.3999 22.7134C24.0443 22.7134 24.5666 23.2357 24.5666 23.88C24.5666 24.5244 24.0443 25.0467 23.3999 25.0467C22.7556 25.0467 22.2333 24.5244 22.2333 23.88ZM16.7333 27.0467C16.0889 27.0467 15.5666 27.569 15.5666 28.2134C15.5666 28.8577 16.0889 29.38 16.7333 29.38C17.3776 29.38 17.8999 28.8577 17.8999 28.2134C17.8999 27.569 17.3776 27.0467 16.7333 27.0467ZM23.3999 31.38C22.7556 31.38 22.2333 31.9024 22.2333 32.5467C22.2333 33.191 22.7556 33.7134 23.3999 33.7134C24.0443 33.7134 24.5666 33.191 24.5666 32.5467C24.5666 31.9024 24.0443 31.38 23.3999 31.38Z",
    fill: "#D2294B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.791 58.2715H134.878",
    stroke: "#272525",
    strokeWidth: 0.555733,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.531 53.3013H137.617C137.98 53.3013 138.162 53.3013 138.315 53.3195C139.368 53.4453 140.197 54.1976 140.336 55.1535C140.356 55.292 140.356 55.4568 140.356 55.7866",
    stroke: "#272525",
    strokeWidth: 0.555733
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.272 56.1061C126.272 55.4795 126.272 55.1661 126.326 54.9051C126.565 53.7561 127.555 52.8573 128.821 52.6406C129.109 52.5913 129.454 52.5913 130.145 52.5913C130.447 52.5913 130.599 52.5913 130.744 52.6036C131.371 52.6568 131.965 52.8803 132.45 53.245C132.562 53.3295 132.669 53.4266 132.883 53.6208L133.314 54.0115C133.952 54.5908 134.271 54.8804 134.654 55.0734C134.864 55.1794 135.086 55.2631 135.317 55.3229C135.738 55.4317 136.189 55.4317 137.092 55.4317H137.384C139.444 55.4317 140.474 55.4317 141.144 55.9781C141.205 56.0284 141.264 56.0816 141.319 56.1374C141.921 56.745 141.921 57.6796 141.921 59.5488V61.1125C141.921 63.7905 141.921 65.1295 141.005 65.9614C140.088 66.7934 138.612 66.7934 135.661 66.7934H132.531C129.581 66.7934 128.105 66.7934 127.188 65.9614C126.272 65.1295 126.272 63.7905 126.272 61.1125V56.1061Z",
    fill: "white",
    stroke: "#272525",
    strokeWidth: 0.555733
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6777 71.0993L60.932 13.1049C61.1682 11.4458 62.8082 10.1961 64.6337 10.3602L101.864 13.7082L114.94 29.1769L108.262 76.0978C108.026 77.7569 106.386 79.0066 104.561 78.8424L55.5144 74.4319C53.6897 74.2678 52.4415 72.759 52.6777 71.0993Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 0.67331
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 38.5037,
    height: 16.7213,
    rx: 2.01993,
    transform: "matrix(0.996287 0.0900349 -0.140297 0.990597 64.1747 52.4639)",
    fill: "#FFC1C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6538 64.996L73.5984 58.3262L76.6447 58.6015C77.3889 58.6687 77.9361 58.9098 78.2861 59.3247C78.637 59.7333 78.7652 60.2719 78.6705 60.9404C78.5758 61.609 78.2998 62.1142 77.8426 62.4562C77.3854 62.7981 76.7846 62.9355 76.0404 62.8682L74.4605 62.7255L74.1202 65.1285L72.6538 64.996ZM74.6213 61.5902L75.9552 61.7107C76.731 61.7808 77.1662 61.4816 77.2609 60.8131C77.3538 60.1571 77.0124 59.7941 76.2366 59.724L74.9027 59.6034L74.6213 61.5902Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9361 65.5637L79.8808 58.8939L82.4919 59.1299C83.6271 59.2325 84.4659 59.6021 85.0081 60.2388C85.5512 60.8692 85.7472 61.7173 85.5963 62.7832C85.4453 63.8491 85.0165 64.644 84.31 65.1678C83.6034 65.6916 82.6825 65.9023 81.5472 65.7997L78.9361 65.5637ZM80.5727 64.4947L81.6322 64.5905C83.0513 64.7187 83.8618 64.0701 84.0637 62.6447C84.2647 61.2256 83.6556 60.4519 82.2365 60.3237L81.177 60.2279L80.5727 64.4947Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2625 66.2258L87.2071 59.556L91.7103 59.9629L91.5482 61.1077L88.5113 60.8333L88.2809 62.4605L91.1096 62.7161L90.9474 63.8609L88.1187 63.6052L87.7288 66.3583L86.2625 66.2258Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.898 25.0663L102.357 14.8204L114.503 29.2467L103.611 28.2682C101.865 28.1113 100.67 26.6621 100.898 25.0663Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 0.67331
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4939 33.9867C69.6788 34.0057 69.8474 33.8715 69.8704 33.687L70.4439 29.0865C70.5129 28.533 71.0187 28.1305 71.5736 28.1874L79.0134 28.9513C79.1983 28.9702 79.3669 28.8361 79.3899 28.6516L93.5998 30.1105C93.5768 30.295 93.708 30.4599 93.893 30.4789L101.333 31.2428C101.888 31.2997 102.282 31.7946 102.213 32.3481L101.639 36.9487C101.616 37.1332 101.747 37.2981 101.932 37.3171L100.869 45.8501C100.684 45.8311 100.515 45.9653 100.492 46.1498L99.9184 50.7504C99.8494 51.3039 99.3437 51.7064 98.7888 51.6494L91.349 50.8856C91.1641 50.8666 90.9955 51.0008 90.9725 51.1853L76.7626 49.7264C76.7856 49.5419 76.6543 49.3769 76.4694 49.3579L69.0296 48.5941C68.4747 48.5371 68.0808 48.0423 68.1498 47.4888L68.7234 42.8882C68.7464 42.7037 68.6151 42.5387 68.4301 42.5197L69.4939 33.9867Z",
    stroke: "#BFBFBF",
    strokeWidth: 0.67331,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "13.47 13.47"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90.2025,
    y1: 43.8435,
    x2: 94.7765,
    y2: 44.3609,
    stroke: "#BFBFBF",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 72.7481,
    y1: 45.0149,
    x2: 94.4251,
    y2: 47.4672,
    stroke: "#BFBFBF",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 90.5188,
    y1: 41.0476,
    x2: 95.0928,
    y2: 41.565,
    stroke: "#BFBFBF",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 90.8351,
    y1: 38.2522,
    x2: 95.4091,
    y2: 38.7696,
    stroke: "#BFBFBF",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 91.2217,
    y1: 34.8352,
    x2: 95.7957,
    y2: 35.3526,
    stroke: "#BFBFBF",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0007,
    y: 32.1465,
    width: 15.3344,
    height: 10.0035,
    rx: 1.34662,
    transform: "rotate(6.45461 74.0007 32.1465)",
    stroke: "#BFBFBF",
    strokeWidth: 0.336655
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9811 37.1207L76.2359 36.2691C76.8888 35.826 77.7823 35.9567 78.2794 36.5681L80.7701 39.631C81.1691 40.1216 81.8687 40.2615 82.4285 39.9626L82.6384 39.8505C83.4438 39.4202 84.448 39.5942 85.0591 40.2699L86.954 42.3652",
    stroke: "#BFBFBF",
    strokeWidth: 0.437652,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.848,
    cy: 36.5512,
    rx: 1.31438,
    ry: 1.3048,
    transform: "rotate(6.45461 85.848 36.5512)",
    stroke: "#BFBFBF",
    strokeWidth: 0.437652
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2655 74.4025V16.8C37.2655 15.1678 38.7415 13.7873 40.637 13.7873H78.9437L94.4632 27.8052V74.4025C94.4632 76.0346 92.9872 77.4151 91.0917 77.4151H40.637C38.7422 77.4151 37.2655 76.0353 37.2655 74.4025Z",
    fill: "white",
    stroke: "#969696",
    strokeWidth: 0.67331
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2033,
    y: 55.5327,
    width: 38.9518,
    height: 16.1594,
    rx: 2.01993,
    fill: "#D2294B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5895 66.9792V60.2461H59.6472C60.3942 60.2461 60.9702 60.4371 61.3754 60.8191C61.7805 61.1948 61.9831 61.7201 61.9831 62.395C61.9831 63.0699 61.7805 63.5983 61.3754 63.9803C60.9702 64.3624 60.3942 64.5534 59.6472 64.5534H58.0614V66.9792H56.5895ZM58.0614 63.4073H59.4003C60.1789 63.4073 60.5683 63.0699 60.5683 62.395C60.5683 61.7328 60.1789 61.4017 59.4003 61.4017H58.0614V63.4073Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8953 66.9792V60.2461H65.5161C66.6556 60.2461 67.5387 60.539 68.1654 61.1247C68.7922 61.7041 69.1055 62.5318 69.1055 63.6079C69.1055 64.6839 68.7922 65.5148 68.1654 66.1005C67.5387 66.6863 66.6556 66.9792 65.5161 66.9792H62.8953ZM64.3671 65.7663H65.4307C66.855 65.7663 67.5672 65.0468 67.5672 63.6079C67.5672 62.1753 66.855 61.459 65.4307 61.459H64.3671V65.7663Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2489 66.9792V60.2461H74.7689V61.4017H71.7208V63.0444H74.56V64.2H71.7208V66.9792H70.2489Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.556 24.3666V14.2108L93.9281 27.2535H82.7714C80.9644 27.2535 79.556 25.9314 79.556 24.3666Z",
    fill: "white",
    stroke: "#969696",
    strokeWidth: 0.67331
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5419 36.596C49.7279 36.596 49.8786 36.4452 49.8786 36.2593V31.6303C49.8786 31.0725 50.3308 30.6203 50.8886 30.6203H58.3766C58.5625 30.6203 58.7132 30.4696 58.7132 30.2837H73.016C73.016 30.4696 73.1667 30.6203 73.3526 30.6203H80.8406C81.3984 30.6203 81.8506 31.0725 81.8506 31.6303V36.2593C81.8506 36.4452 82.0013 36.596 82.1873 36.596V45.1807C82.0013 45.1807 81.8506 45.3314 81.8506 45.5173V50.1463C81.8506 50.7041 81.3984 51.1563 80.8406 51.1563H73.3526C73.1667 51.1563 73.016 51.307 73.016 51.493H58.7132C58.7132 51.307 58.5625 51.1563 58.3766 51.1563H50.8886C50.3308 51.1563 49.8786 50.7041 49.8786 50.1463V45.5173C49.8786 45.3314 49.7279 45.1807 49.5419 45.1807V36.596Z",
    stroke: "#1D1D1D",
    strokeWidth: 0.67331,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "13.47 13.47"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 73.0766,
    y1: 44.1247,
    x2: 77.6797,
    y2: 44.1247,
    stroke: "#838383",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 55.8645,
    y1: 47.2506,
    x2: 77.6797,
    y2: 47.2506,
    stroke: "#838383",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 73.0766,
    y1: 41.3112,
    x2: 77.6797,
    y2: 41.3112,
    stroke: "#838383",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 73.0766,
    y1: 38.4977,
    x2: 77.6797,
    y2: 38.4977,
    stroke: "#838383",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 73.0766,
    y1: 35.0587,
    x2: 77.6797,
    y2: 35.0588,
    stroke: "#838383",
    strokeWidth: 0.403986,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6625,
    y: 34.3232,
    width: 15.3344,
    height: 10.0035,
    rx: 1.34662,
    stroke: "#838383",
    strokeWidth: 0.336655
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1959 39.1557L58.347 38.1684C58.9459 37.6547 59.8485 37.6842 60.4112 38.2357L63.2304 40.9992C63.682 41.4419 64.393 41.5023 64.9155 41.1423L65.1115 41.0073C65.8635 40.4893 66.8809 40.5493 67.564 41.152L69.6825 43.021",
    stroke: "#838383",
    strokeWidth: 0.437652,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.9299,
    cy: 37.3683,
    rx: 1.31438,
    ry: 1.3048,
    stroke: "#838383",
    strokeWidth: 0.437652
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-icon.ae29b3c00e4ea3b2d815254aee7c4701.svg";